export const UPDATE_CURRENT_PAGE_FEEDS = 'UPDATE_CURRENT_PAGE_FEEDS';
